<script setup>
import { is_role } from '@/helpers/back'
import ThemeToggler from '@/components/ThemeToggler.vue'
import { useStore } from '@/store/store'
import { computed, ref } from 'vue'
import axios from 'axios'

const store = useStore()
const user = computed(() => store.getP('user') || {})
const v = ref(process.env.VUE_APP_VERSION)
const logout_ = () => {
  store.deleteP('access_token')
  store.deleteP('refresh_token')
  store.deleteP('user')
  delete axios.defaults.headers.common['Authorization']
  window.location.href = '/login'
}

</script>
<template>
  <footer>
    <div class="container">

      <div class="row my-2 mx-1">
        <div class="col">

        </div>
        <div class="col"></div>

        <div class="col-3">
            <div class="w-100 d-flex flex-row justify-content-end align-bottom gap-2 text-secondary small">
              <ThemeToggler />

              <span :title="JSON.stringify(user)">{{ user?.login }} #{{ user.id }}</span> /
              <span role="button" @click="logout_" v-if="user"  title="Разлогиниться и сбросить кеши">
                logout
              </span> /


              <router-link
                to="/maint/dash"
                class="text-secondary text-end text-decoration-none"
                v-if="is_role('admin')">v.{{ v }}
              </router-link>
              <span class="text-secondary text-end" v-else>v.{{ v }}</span>
          </div>
        </div>
      </div>
    </div>
  </footer>

</template>